module.exports = __webpack_public_path__ + "static/media/superuser-detail.1134b594.svg";